import React, { useEffect, useCallback } from 'react';
import styles from './index.module.scss';
import classnames from 'classnames';
import useSetState from 'customHooks/setState';
import Bopomofo from 'components/common/Bopomofo';
import Icon from 'components/Icon';

const getPageCount = () => {
  const windowWidth = window.innerWidth;
  if (1680 < windowWidth && windowWidth <= 1920) return 23;
  if (1440 < windowWidth && windowWidth <= 1680) return 20;
  if (1280 < windowWidth && windowWidth <= 1440) return 17;
  if (1024 < windowWidth && windowWidth <= 1280) return 14;
  if (640 < windowWidth && windowWidth <= 1024) return 11;
  return 20
}


const WordContentList = ({
  zhuyin = false,
  word,
  className,
  data = [],
  onChange = () => { }
}) => {
  const [{ dataSet, currentPageIndex }, setState] = useSetState({
    dataSet: null,
    currentPageIndex: 0
  })
  const maxPage = dataSet ? Object.keys(dataSet).length - 1 : 0;

  const groupByPage = useCallback((data) => {
    if (!data) return;
    const dataMap = {};
    let pageIndex = -1; // for start to index 0

    data.forEach((item, index) => {
      if (index % getPageCount() === 0) {
        pageIndex += 1;
      }

      if (!dataMap[pageIndex]) dataMap[pageIndex] = [];
      dataMap[pageIndex].push(item);
      if (item.value === word) {
        setState({ currentPageIndex: pageIndex })
      }
    })
    return dataMap
  }, [setState, word])


  useEffect(() => {
    const dataSet = groupByPage(data)
    setState({ dataSet })
  }, [data, groupByPage, setState])

  const prevPage = () => {
    setState({ currentPageIndex: Math.max(currentPageIndex - 1, 0) })
  };

  const nextPage = () => {
    setState({ currentPageIndex: Math.min(currentPageIndex + 1, maxPage) })
  }

  return (
    <div className={classnames(styles.wordContentList, className)}>
      <div className={classnames(styles.controls, {
        [styles.disabled]: currentPageIndex === maxPage
      })} onClick={nextPage}>
        <Icon type="text" name="angleLeft" />
      </div>
      <div className={styles.wordList}>
        {
          dataSet && dataSet[currentPageIndex].map((item, index) => {
            return <div key={index} className={classnames(styles.word, {
              [styles.zhuyin]: zhuyin,
              [styles.active]: item.value.includes(word)
            })} onClick={() => onChange({
              word: item.value,
            })}>
              {
                zhuyin && Array.isArray(item.label) ? (
                  <>
                    {
                      item.label.map(item => (
                        <Bopomofo
                          zhuyin={item}
                        />
                      ))
                    }
                  </>
                ) : item.label
              }
            </div>
          })
        }
      </div>
      <div className={classnames(styles.controls, {
        [styles.disabled]: currentPageIndex === 0
      })} onClick={prevPage}>
        <Icon type="text" name="angleRight" />
      </div>
    </div>
  )
}


export default WordContentList;